import React, { useState, useEffect, useCallback } from "react";
import styles from "./index.module.css";
import { get, post } from "../../axios";
import SaveIcon from '@mui/icons-material/Save';
import IconButton from '@mui/material/IconButton';

export default function SolutionEditor({ eightLettersResult, isMale }) {
  const [documents, setDocuments] = useState("");
  const [fourPillar, setFourPillar] = useState("");
  const [status, setStatus] = useState(""); // feedback message

  // Derive fourPillar from eightLettersResult
  useEffect(() => {
    if (
      eightLettersResult &&
      eightLettersResult.letterAddress &&
      eightLettersResult.letterAddress.string &&
      eightLettersResult.letterAddress.string.length >= 8
    ) {
      const fp = eightLettersResult.letterAddress.string.substring(0, 8);
      setFourPillar(fp);
    } else {
      setFourPillar("");
      setDocuments("");
    }
  }, [eightLettersResult]);

  // Fetch existing documents whenever fourPillar changes
  useEffect(() => {
    if (!fourPillar) return;

    setStatus("Loading…");
    get(`api/solution/fourpillar/${encodeURIComponent(fourPillar)}/${isMale}`)
      .then((res) => {
        if (res.data && res.data.success && res.data.data) {
          setDocuments(res.data.data.documents || "");
          setStatus("");
        } else {
          setDocuments("");
          setStatus("未能找到此八字");
        }
      })
      .catch(() => {
        setDocuments("");
        setStatus("此八字未有紀錄");
      });
  }, [fourPillar, isMale]);

  const handleSave = useCallback(() => {
    if (!fourPillar) return;
    setStatus("儲存中…");
    post("api/solution", { fourpillar: fourPillar, isMale, documents })
      .then((res) => {
        if (res.data && res.data.success) {
          setStatus("已儲存。");
        } else {
          setStatus("儲存失敗。");
        }
      })
      .catch(() => {
        setStatus("儲存錯誤。");
      });
  }, [fourPillar, isMale, documents]);

  if (!fourPillar) return null;

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        {/* <span className={styles.label}>Solution Editor</span> */}
        <span className={styles.fourPillar}>{fourPillar}</span>
        {status && <span className={styles.status}>{status}</span>}
      </div>
      <div className={styles.editorRow}>
        <textarea
          className={styles.textarea}
          value={documents}
          onChange={(e) => setDocuments(e.target.value)}
          placeholder="輸入算命結果"
        />
        <IconButton
          className={styles.saveButton}
          onClick={handleSave}
          title="儲存"
          color="primary"
        >
          <SaveIcon />
        </IconButton>
      </div>
    </div>
  );
}
